import { NgModule, Type } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DsIconModule, DsTooltipModule, DsToggleModule, DsSearchBarModule } from '@levelaccess/design-system';
import { CompoundNavbarComponent } from './compound-navbar.component';
import { CompoundTopNavbarComponent } from './compound-top-navbar/compound-top-navbar.component';
import { TopNavNotificationsComponent } from './compound-top-navbar/top-navbar-notifications/top-nav-notifications.component';
import { CompoundThirdLevelNavbarComponent } from './compound-third-level-navbar/compound-third-level-navbar.component';
import { SharedModule } from '../../shared/shared.module';
import { CompoundNavbarLinkComponent } from './compound-navbar-link/compound-navbar-link.component';
import { TopNavbarProfileDropdownComponent } from './compound-top-navbar/top-navbar-profile-dropdown/top-navbar-profile-dropdown.component';
import { CompoundSecondLevelNavbarComponent } from './compound-second-level-navbar/compound-second-level-navbar.component';
import { TopNavbarControlHubDropdownComponent } from './compound-top-navbar/top-navbar-control-hub-dropdown/top-navbar-control-hub-dropdown.component';
import { MobileTopNavbarMenuModalComponent } from './compound-top-navbar/mobile-top-navbar-menu-modal/mobile-top-navbar-menu-modal.component';
import { MobileSecondNavbarMenuModalComponent } from './compound-second-level-navbar/mobile-second-navbar-menu-modal/mobile-second-navbar-menu-modal.component';
import { WebsitesAppsSelectComponent } from './websites-apps-select/websites-apps-select.component';
import { WorkspacesSelectComponent } from './compound-second-level-navbar/mobile-second-navbar-menu-modal/workspaces-select/workspaces-select.component';
import { CompoundTopNavbarUnauthenticatedComponent } from './compound-top-navbar/compound-top-navbar-unauthenticated.component';
import { NewNavToggleComponent } from './compound-top-navbar/new-nav-toggle/new-nav-toggle.component';
import { SwitcherContentComponent } from '../vertical-navigation/navigation-context-switcher/switcher-content/switcher-content.component';
import { SwitcherModalComponent } from './compound-top-navbar/switcher-modal/switcher-modal.component';

const compoundNavbarComponents: Type<any>[] = [
  CompoundNavbarComponent,
  CompoundTopNavbarComponent,
  CompoundTopNavbarUnauthenticatedComponent,
  NewNavToggleComponent,
  CompoundThirdLevelNavbarComponent,
  CompoundNavbarLinkComponent,
  TopNavNotificationsComponent,
  TopNavbarProfileDropdownComponent,
  TopNavbarControlHubDropdownComponent,
  CompoundSecondLevelNavbarComponent,
  MobileTopNavbarMenuModalComponent,
  MobileSecondNavbarMenuModalComponent,
  WebsitesAppsSelectComponent,
  WorkspacesSelectComponent,
];

@NgModule({
  declarations: [...compoundNavbarComponents],
  exports: [...compoundNavbarComponents],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    DsIconModule,
    DsTooltipModule,
    DsToggleModule,
    DsSearchBarModule,
    SwitcherContentComponent,
    SwitcherModalComponent,
  ],
})
export class CompoundNavbarModule {}
